__turbopack_context__.v({
  "heroCommon": "STHeroCommon-module__0sStvq__heroCommon",
  "heroCommonContent": "STHeroCommon-module__0sStvq__heroCommonContent",
  "heroCommonDescription": "STHeroCommon-module__0sStvq__heroCommonDescription",
});
